import { complement } from 'ramda';

import isString from './isString';

/**
 * Checks if input value is complement of `String`.
 *
 * @func isNotString
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.4.0|v0.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {Boolean}
 * @see {@link RA.isString|isString}
 * @example
 *
 * RA.isNotString('abc'); //=> false
 * RA.isNotString(1); //=> true
 */
var isNotString = /*#__PURE__*/complement(isString);

export default isNotString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isNotString.js
// module id = 734
// module chunks = 0